import axios from 'axios';

export default {
    recordAttendance(meetingId) {

        var options = {
            url: window.apiUrl + '/meeting/attendance',
            method: 'POST',
            data: {id:meetingId},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    add(context, session) {
        var self = this;
        var options = {
            url: window.apiUrl + '/meeting',
            method: 'POST',
            data: session,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    addCampusMeetings(context, meetings) {
        var self = this;
        var options = {
            url: window.apiUrl + '/campus-meetings',
            method: 'POST',
            data: {meetings: meetings},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    addCampusMeetingNote(context, note) {
        var self = this;
        var options = {
            url: window.apiUrl + '/campus-meeting-note',
            method: 'POST',
            data: {note: note},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    update(context, data) {
       
        var options = {
            url: window.apiUrl + '/meeting',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'PATCH',
        }         

        return axios.request(options).then(function(response) {
             return response;

        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
    get(context, groupId, mentorMeetings) {
        let url = window.apiUrl + '/meetings/' + groupId;
        if (mentorMeetings) url += '?mentor_meetings=' + mentorMeetings

        console.log(url)
        var options = {
            url: url,
            params: {
                // cache: 'meetings'
            },
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getForTerm(termId) {
        let url = window.apiUrl + '/term-meetings/' + termId;        
        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getSupervisorMeetings(context) {
        var options = {
            method:'GET',
            url: window.apiUrl + '/supervisor-meetings',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getLatest(context, courseId) {
        var self = this;
        var options = {
            url: window.apiUrl + '/meeting/next?courseId=' + courseId,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getAttendance(context, group, start, end) {
        let url = window.apiUrl + '/meeting/attendance?group=' + group + '&start=' + start + '&end=' + end;
        console.log(url);
        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });   
    },
    addComment(context, comment) {
        var self = this;
        var options = {
            url: window.apiUrl + '/video-comment',
            method: 'POST',
            data: comment,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getComments(context, recordingId) {
        var self = this;
        var options = {
            url: window.apiUrl + '/video-comment/' + recordingId,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getCampusMeetings(context, recordingId) {
        var self = this;
        var options = {
            url: window.apiUrl + '/campus-meetings',            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },

    update(context, update) {
       
        var options = {
            url: window.apiUrl + '/meeting',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: update,
            method: 'PATCH',
        }         

        return axios.request(options).then(function(response) {
             return response;

        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
    delete(context, id, location) {
       
        var options = {
            url: window.apiUrl + '/meeting/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token},     
            data: {location: location},
            method: 'DELETE',
        }         

        return axios.request(options).then(function(response) {
             return response;

        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
};



// WEBPACK FOOTER //
// ./src/services/meetings/index.js